import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './Tag.pcss';
import {CustomPropShapes, tagTypes} from '../../constants';

const Tag = ({className, children, type = tagTypes.PROMO}) => {
    return (
        <span className={className}>
            <span className={cx(styles.tag, styles[type])}>{children}</span>
        </span>
    );
};

Tag.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    type: CustomPropShapes.oneOfConstant(tagTypes)
};

export default Tag;
